module.exports = __webpack_public_path__ + "img/7d0a2d4.jpg";